import { COLORS, TYPE, SPACE } from '../tokens'
import SectionLabel from '../SectionLabel'

// Section 5: numbered list 01/02/03 with teal numerals.
// Recommendation-type findings become broker discussion items.
export default function BrokerConversation({ findings }) {
  const items = (findings || []).filter(f =>
    f.finding_type === 'recommendation' && f.confidence_tier !== 'suppressed'
  )
  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
      <SectionLabel>For the broker conversation</SectionLabel>
      {items.length === 0 ? (
        <p style={{ ...TYPE.body, color: COLORS.mutedText }}>
          The Specialist did not surface distinct broker-facing items for this review.
        </p>
      ) : (
        <ol style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {items.map((f, idx) => (
            <li key={f.id} style={{ display: 'grid', gridTemplateColumns: '56px 1fr', gap: '20px', marginBottom: '32px' }}>
              <span style={{ ...TYPE.hero, color: COLORS.accent, textAlign: 'right' }}>
                {String(idx + 1).padStart(2, '0')}
              </span>
              <div>
                <h4 style={{ ...TYPE.sectionHead, color: COLORS.bodyText, margin: '0 0 8px' }}>{f.title}</h4>
                <p style={{ ...TYPE.body, color: COLORS.bodyText, margin: 0 }}>{f.detail}</p>
                {f.rationale && (
                  <p style={{ ...TYPE.supporting, color: COLORS.mutedText, marginTop: '8px' }}>{f.rationale}</p>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
